import { handleShowModal } from 'components/global/_helpers/global.helpers';
import ContextMenu from 'components/global/ContextMenu';

const InvestorDealflowContextMenu = ({ dealflowItem }) => (
  <ContextMenu
    menuItems={[
      {
        label: 'Edit/Move',
        onClick: () => handleShowModal('investor-dealflow-edit', {
          ...dealflowItem,
        }),
      },
      {
        label: 'Remove from Deal',
        onClick: () => handleShowModal('investor-dealflow-delete', {
          id: dealflowItem?.id,
          name: dealflowItem.companyName,
        }),
      },
    ]}
  />
);

export default InvestorDealflowContextMenu;
